import { render, staticRenderFns } from "./DataTableFooter.vue?vue&type=template&id=7ba3bbf4&scoped=true"
import script from "./DataTableFooter.vue?vue&type=script&lang=js"
export * from "./DataTableFooter.vue?vue&type=script&lang=js"
import style0 from "./DataTableFooter.vue?vue&type=style&index=0&id=7ba3bbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba3bbf4",
  null
  
)

export default component.exports